/* eslint-disable no-console */
// 工具类，公用方法

'use strict';

/**
 * 处理数组类型传参的方法
 * @param configItem
 * @returns {string}
 */

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function processingArrays(configItem) {
    var configItemDetail = [];

    for (var i = 0, l = configItem.length; i < l; i++) {
        switch (Object.prototype.toString.call(configItem[i])) {
            case '[object Object]':
                configItemDetail.push((0, _stringify2.default)(configItem[i]));
                break;
            case '[object String]':
            case '[object Number]':
                configItemDetail.push(configItem[i].toString());
                break;
        }
    }
    return encodeURIComponent('["' + configItemDetail.join('","') + '"]') + '&';
}

/**
 * @param {*} config 服务端的传参，待格式化的数据
 */
function dataFormate(config) {
    var configStr = '';
    var configItem = void 0;

    for (var key in config) {
        configItem = config[key];
        switch (Object.prototype.toString.call(configItem)) {
            case '[object Array]':
                configStr += key + '=' + processingArrays(configItem);
                break;
            case '[object Object]':
                configStr += key + '=' + encodeURIComponent((0, _stringify2.default)(configItem)) + '&';
                break;
            case '[object Boolean]':
                configStr += key + '=' + (configItem ? 'true' : 'false') + '&';
                break;
            case '[object String]':
            case '[object Number]':
                configStr += key + '=' + encodeURIComponent(configItem.toString()) + '&';
                break;
        }
    }

    return configStr;
}

/**
 *
 * @param {string} str 待判断数据
 */
function isString(str) {
    return typeof str == 'string' && str.constructor === String;
}

/**
 * 通过iframe方式调用客户端接口url
 * @param  {string} native    [变量空间]
 * @param  {string} stream    [接口列表对应的接口名]
 * @param  {string} configStr [接口传参的JSONstring]
 * @param  {string} successID [成功返回的回调方法名]
 * @param  {string} errorID   [接口失败的回调方法名]
 * @return {[type]}           [description]
 */
function callUrl(native, stream, configStr, successID, errorID) {
    var iframe = document.createElement('IFRAME');

    if (native.debugMode) {
        console.log('before call stream: ' + stream);
        console.log(stream + '?' + configStr + 'success=' + successID + '&error=' + errorID);
    }
    if (isString(successID) && isString(errorID)) {
        var bridgeUrl = stream + '?' + configStr + 'success=' + successID + '&error=' + errorID;

        bridgeUrl = bridgeUrl + '&bridgeUrl=' + encodeURIComponent(bridgeUrl);
        iframe.setAttribute('width', 0);
        iframe.setAttribute('height', 0);
        iframe.setAttribute('frameborder', 0);
        iframe.setAttribute('src', bridgeUrl);
        document.documentElement.appendChild(iframe);
        setTimeout(function () {
            iframe.parentNode.removeChild(iframe);
        }, 500);
    } else {
        throw new ReferenceError('sui-sdk\u65B9\u6CD5\u540D\u7C7B\u578B\u9519\u8BEF[\u5FC5\u987B\u4E3AString\u7C7B\u578B]\uFF0CsuccessID\uFF1A' + successID + ', errorID: ' + errorID);
    }
}

/**
 * 客户端调用页面端方法的执行结果的回调
 * @param {*} callbackID 客户端定下的回调方法名id
 * @param {*} resultDict 网页端返回给服务端的处理结果
 */
function send(callbackID, resultDict) {
    var iframe = document.createElement('IFRAME');

    iframe.setAttribute('src', 'sui-js-callback://callback?callbackId=' + callbackID + '&resultString=' + encodeURIComponent((0, _stringify2.default)(resultDict)));
    iframe.setAttribute('width', 0);
    iframe.setAttribute('height', 0);
    iframe.setAttribute('frameborder', 0);
    document.documentElement.appendChild(iframe);
    setTimeout(function () {
        iframe.parentNode.removeChild(iframe);
        iframe = null;
    }, 500);
}

/**
 * @param  {string} native    [变量空间]
 * @param  {string} success    [成功回调方法名]
 * @param  {string} error    [失败回调方法名]
 * 释放空间
 */
function clear(native, success, error) {
    if (native.debugMode) {
        console.log('不删除客户端回调方法', success, error);
    }
    // delete native[success];
    // delete native[error];
}

/**
 *
 * @param {Object} obj 判断对象
 */
function isPromise(obj) {
    // return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
    return obj && typeof obj.then === 'function';
}

/**
 * 是否支持sdk方法
 */
function sdkEnable() {
    var ua = window.navigator.userAgent.toLowerCase();

    return (/mymoneysms/i.test(ua) || /(feideeandroid|mymoney)/i.test(ua)
    );
}

exports.default = {
    processingArrays: processingArrays,
    dataFormate: dataFormate,
    callUrl: callUrl,
    clear: clear,
    send: send,
    isPromise: isPromise,
    sdkEnable: sdkEnable
};